import { axiosPredsenseInstance } from "../App";
import { IOrganization } from "../types/Organization";

export const getOrganizations = () => {
  return axiosPredsenseInstance
    .get("/api/organization/all")
    .then((res) => res.data);
};

export const getOrganizationByUuid = (organizationUuid: string) => {
  return axiosPredsenseInstance
    .get(`/api/organization/${organizationUuid}`)
    .then((res) => res.data);
};

export const createOrganization = (data: Partial<IOrganization>) => {
  return axiosPredsenseInstance
    .post("/api/organization/create", data)
    .then((res) => res.data);
};
